import { createSelector } from '@ngrx/store'

export const getMobileUsersState = createSelector(
  (state: any) => state.mobileUsers,
  (state: any) => state.get('list'),
)

export const getCreateMobileUserState = createSelector(
  (state: any) => state.mobileUsers,
  (state: any) => state.get('createUser'),
)

export const getUpdateMobileUserState = createSelector(
  (state: any) => state.mobileUsers,
  (state: any) => state.get('updateUser'),
)

export const getUpdateMobileUserTasksState = createSelector(
  (state: any) => state.mobileUsers,
  (state: any) => state.get('tasks'),
)

export const getReissueActivationCodeState = createSelector(
  (state: any) => state.mobileUsers,
  (state: any) => state.get('reissueActivationCode'),
)
